import { API } from 'src/utils/interceptor'

/**
 * Create or reuse a VenueSupplier from a printed Non-OMS supplier name
 * during invoice upload review (Chunk 11).
 */
export async function createManualVenueSupplierFromUpload({
  venueId,
  supplierName,
  sageSupplierAccountNumber = '',
  apiPost = API.post,
} = {}) {
  if (!venueId) {
    throw new Error('Venue is required to create a supplier')
  }
  const name = String(supplierName || '').trim()
  if (!name) {
    throw new Error('Supplier name is required')
  }

  const response = await apiPost(
    'api2',
    `venue/${venueId}/suppliers/manual-from-upload`,
    {
      body: {
        supplierName: name,
        sageSupplierAccountNumber:
          String(sageSupplierAccountNumber || '').trim() || undefined,
      },
    },
  )

  if (!response?.success || !response?.data?.venueSupplier?._id) {
    throw new Error(
      response?.message || 'Could not create supplier for this venue',
    )
  }

  return response.data
}
